import { render, staticRenderFns } from "./freightNew.vue?vue&type=template&id=75464d37&scoped=true"
import script from "./freightNew.vue?vue&type=script&lang=js"
export * from "./freightNew.vue?vue&type=script&lang=js"
import style0 from "./freightNew.vue?vue&type=style&index=0&id=75464d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75464d37",
  null
  
)

export default component.exports